//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <!-- :class="{'dragging-mode' : draggableDataDraggingMode == true}" -->
  <draggable v-if="(dataProp != null) && (optionsProp != null)" v-model="dataProp"
  :options="optionsProp.draggableComponent"
  :move="draggableDataOnMove" @change="draggableDataOnChange" @start="draggableDataDraggingModeOnChange" @end="draggableDataDraggingModeOnChange">
    <transition-group name="dtv-flip-list" tag="ul"
    class="dtv-properties-list-group"
    :style="(optionsProp.isRoot == true) ? 'margin-left:0px' : ''"
    :class="{'dtv-properties-list-group-show-empty' : (dataProp.length == 0)}">

      <!-- @mouseover="draggTreeviewMouseOver(element)" @mouseout="draggTreeviewMouseOut(element)"> -->
      <li class="dtv-properties-list-group-item"
      :class="{'dtv-dragging-element' : (commonDataBusProp.draggingElement != null) && (commonDataBusProp.draggingElement.val.id == element.val.id)}"
      v-for="element in dataProp" :key="element.val.id">

        <div class="dtv-property-box" :class="getPropertyBoxClasses(element)">
          <div style="float:left; font-size:17px;">
            <Icon type="grid" class="dtv-property-box-handle"></Icon>
          </div>
          <div v-if="element.children.length > 0" style="float:left; font-size:17px; padding: 0 5px 0 3px; cursor:pointer;" @click="draggableDataToggleItem(element)">
            <Icon type="arrow-right-b"></Icon>
          </div>
          <div style="float:right;" class="dtv-property-box-action-button">
            <Button type="text" style="border-radius:0px; margin:-5px 0 0 10px; padding:0px; color:rgb(149,158,165); font-size:17px;" @click="dataRowOnDelete(element)">
              <Icon type="trash-b"></Icon>
            </Button>
          </div>
          <div @click="dataRowOnSelect(element)" style="padding-top:3px; height:17px; cursor:pointer">
            <slot name="propertyBox" :dataRow="element"> Нет данных </slot>
          </div>
        </div>

        <div v-if="((element.children.length > 0) && (element.ui.toggle == true)) || doesEmptyChildrenListShow(element)">
          <dragg-treeview  :data.sync="element.children" :commondatabus2.sync="commonDataBusProp" :options="optionsPropForChildren"
          @change="emitChangeToUpper"
          @select="emitSelectToUpper"
          @delete="emitDeleteToUpper"
          style="padding-top:1px;">
            <template slot="propertyBox" scope="viewProps">
              <slot name="propertyBox" :dataRow="viewProps.dataRow"> Нет данных </slot>
            </template>
          </dragg-treeview>
        </div>
        <!-- <div v-else :class="{'dtv-properties-list-group-show-empty' : (commonDataBusProp.draggingMode == true) && (element.val.id == commonDataBusProp.mouseOverDataItem.val.id)}">
        </div> -->

      </li>

    </transition-group>
  </draggable>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
// import Vue from 'Vue'
// import { mapGetters, mapMutations } from 'vuex'

import draggable from 'vuedraggable'

import draggTreeviewCommonDataBus from '@/technical/components/Treeview/draggTreeviewCommonDataBus'

export default {
  name: 'dragg-treeview',
  props: ['data', 'commondatabus', 'options', 'selectedDataItem'],
  components: { draggable },
  data () {
    return {
      dataPropLocal: null,
      optionsProp: null,
      commonDataBusPropLocal: null
    }
  },
  computed: {
    dataProp: {
      get () {
        return this.dataPropLocal
      },
      set (value) {
        this.dataPropLocal = value
        this.$emit('update:data', value)
      }
    },
    commonDataBusProp: {
      get () {
        return this.commonDataBusPropLocal
      },
      set (value) {
        this.commonDataBusPropLocal = value
        // this.$emit('update:commondatabus', value)
      }
    },
    optionsPropForChildren () {
      var optionsPropForChild = window.cloneObject(this.options)
      optionsPropForChild.isRoot = false
      return optionsPropForChild
    }
  },
  created () {
    this.dataPropLocal = this.data

    // if (this.commondatabus == null) {
    this.commonDataBusPropLocal = draggTreeviewCommonDataBus
      // {
        // selectedDataItem: null,
        // draggingMode: false,

        // mouseOverDataList: null,

        // mouseOverDataItem: {val: {}} // {val: {}} чтобы не проверять по коду mouseOverDataItem на null
        // mouseOverDataItemNewCandidate: {val: {}}, // {val: {}} чтобы не проверять по коду mouseOverDataItemNewCandidate на null
        // mouseOverDataItemNewCandidateTimeoutRunningFlag: false
      // }
    // } else this.commonDataBusPropLocal = this.commondatabus

    this.optionsProp = window.cloneObject(this.options)
    Object.assign(this.optionsProp.draggableComponent, {handle: '.dtv-property-box-handle'})
  },
  watch: {
    data (newData) {
      // console.log('dtv watch.data')
      // console.log(newData)
      this.dataProp = newData
    },
    // commondatabus (newData) {
    //   console.log('dtv watch.commondatabus')
    //   console.log(newData)
    //   this.commonDataBusPropLocal = newData
    // },
    options: function (newOptions) {
      console.log('dtv watch.options')
      this.optionsProp = window.cloneObject(newOptions)
      Object.assign(this.optionsProp.draggableComponent, {handle: '.dtv-property-box-handle'})
    },
    selectedDataItem: function (value) {
      console.log('dtv watch selectedDataItem')
      this.commonDataBusProp.selectedDataItem = value
    }
  },
  methods: {
    getPropertyBoxClasses (item) {
      if (this.isRowSelected(item)) {
        return 'dtv-property-box-selected'
      } else if (this.optionsProp.isRoot === true) {
        return 'dtv-property-box-as-root'
      } else {
        return 'dtv-property-box-as-not-root'
      }
    },
    // draggTreeviewMouseOver (item) {
    //   var thisRef = this
    //   if (thisRef.commonDataBusProp.mouseOverDataItemNewCandidate.val.id == null) {
    //     thisRef.commonDataBusProp.mouseOverDataItemNewCandidate = item
    //   } else {
    //     if (item.val.pathToParent.length >= thisRef.commonDataBusProp.mouseOverDataItem.val.pathToParent) {
    //       thisRef.commonDataBusProp.mouseOverDataItemNewCandidate = item
    //     }
    //   }

    //   if (thisRef.commonDataBusProp.mouseOverDataItemNewCandidateTimeoutRunningFlag === false) {
    //     thisRef.commonDataBusProp.mouseOverDataItemNewCandidateTimeoutRunningFlag = true
    //     setTimeout(function () {
    //       if (thisRef.commonDataBusProp.mouseOverDataItemNewCandidate.val.id !== thisRef.commonDataBusProp.mouseOverDataItem.val.id) {
    //         thisRef.commonDataBusProp.mouseOverDataItem = thisRef.commonDataBusProp.mouseOverDataItemNewCandidate
    //         console.log('>>>> draggTreeviewMouseOver ' + thisRef.commonDataBusProp.mouseOverDataItem.val.id)
    //       }
    //       thisRef.commonDataBusProp.mouseOverDataItemNewCandidateTimeoutRunningFlag = false
    //     }, 100)
    //   }
    // },
    // draggTreeviewMouseOut (item) {
    //   var thisRef = this
    //   thisRef.commonDataBusProp.mouseOverDataItemNewCandidate = {val: {}} // {val: {}} чтобы не проверять по коду mouseOverDataItem на null
    // },
    draggableDataToggleItem (item) {
      item.ui.toggle = !item.ui.toggle
      // и ниже чтобы draggableData перерисовалась - это же перезаупскает перестройку и перерисовку всех объектов переданных в data во всем приложении !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      this.$set(item, 'val', Object.assign({}, item.val))
    },
    doesEmptyChildrenListShow (element) {
      // if (this.commonDataBusProp.mouseOverDataList == null) return false
      // if (this.commonDataBusProp.mouseOverDataList.length < 1) return false
      // if ((this.commonDataBusProp.draggingMode === true) && (this.commonDataBusProp.mouseOverDataList[0].val.pathToParent === element.val.pathToParent)) return true
      if (this.commonDataBusProp.draggingMode !== true) return false

      if ((element.parent == null) && (this.commonDataBusProp.mouseOverDataElementId == null)) return true
      if (element.parent == null) return false
      if (this.commonDataBusProp.mouseOverDataElementId == null) return false

      // if (this.commonDataBusProp.mouseOverDataElement == null) return false
      if (this.commonDataBusProp.mouseOverDataElementId !== element.parent.val.id) return false
      // if (this.commonDataBusProp.mouseOverDataList[0].val.parent == null) return false
      // if (this.commonDataBusProp.mouseOverDataList[0].val.parent.val.id !== element.val.parent.val.id) return false
      return true
    },
    draggableDataOnMove (value) {
      // console.log('draggableDataOnMove')
      // console.log(value)
      if (value.relatedContext.element == null) {
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>> erase ' + this.commonDataBusProp.mouseOverDataElementId)
        this.commonDataBusProp.mouseOverDataElementId = 0
        return true
      }
      if (value.relatedContext.element.parent == null) {
        this.commonDataBusProp.mouseOverDataElementId = null
        // console.log(this.commonDataBusProp.mouseOverDataElementId)
        return true
      }

      // console.log(value.relatedContext.element.val.id)
      this.commonDataBusProp.mouseOverDataElementId = value.relatedContext.element.parent.val.id
      // console.log(this.commonDataBusProp.mouseOverDataElementId)
      this.commonDataBusProp.draggingElement = value.draggedContext.element

      // if (value.relatedContext.list == null) return true
      // if (value.relatedContext.list.length > 0) {
      // this.commonDataBusProp.mouseOverDataList = value.relatedContext.list
        // console.log(this.commonDataBusProp.mouseOverDataList)
      // }

      return true
    },
    draggableDataDraggingModeOnChange (value) {
      console.log('draggableDataDraggingModeOnChange')
      // console.log(value)
      this.commonDataBusProp.draggingMode = !this.commonDataBusProp.draggingMode
      this.commonDataBusProp.draggingElement = null
      this.commonDataBusProp.selectedDataItem = null
      this.commonDataBusProp.mouseOverDataElementId = 0
      // this.commonDataBusProp.mouseOverDataList = null
      this.editingDataRow = null

      if (this.commonDataBusProp.draggingMode === false) this.$emit('change', null) // чтобы два раза не сохранять данные в родительском компоненте и вообще вызывать 'change' только когда закончили dragging а не когда начали
    },
    emitChangeToUpper (value) {
      this.$emit('change', value)
    },
    emitSelectToUpper (value) {
      // console.log('emitSelectToUpper')
      this.$emit('select', value)
    },
    emitDeleteToUpper (value) {
      // console.log('emitDeleteToUpper')
      this.$emit('delete', value)
    },
    draggableDataOnChange (event) { // event можно заменить на: {moved} {removed} {added}
      // console.log('draggableDataOnChange ######')
      // if (this.dataProp.length > 0) console.log(this.dataProp[0].val.title)
      // console.log(event)
      // // this.recalcDraggableDataChainIndxesAndPathToParent(this.dataProp, this.dataProp[0].val.pathToParent)
      // // this.saveAllData() // !!!!!!!!!!!!!!!!!!! НЕ РАСКОМЕНЧИВАТЬ ПОКА
    },
    // saveAllData () {
    //   console.log('saveAllData')
    //   var thisRef = this
    //   thisRef.$message.warning('Данные начали сохраняться')
    //   async.each(thisRef.data, function (dataItem, callback) {
    //     dataItem.save()
    //     .then(function (response) {
    //       dataItem.val = response.data
    //       callback()
    //     })
    //     .catch((error) => callback(error))
    //   }, function (error) {
    //     if (error !== null) serverErrorHandling(error, thisRef)
    //     else {
    //       thisRef.$message.success('Данные сохранены на сервер')
    //     }
    //   })
    // },
    dataRowOnDelete (value) {
      // console.log('dataRowOndelete ####')
      // console.log(value.val.id)
      // this.commonDataBusProp.selectedDataItem = value
      this.$emit('delete', value)
    },
    dataRowOnSelect (value) {
      console.log('dataRowOnSelect ####')
      console.log(value.val.id)
      this.commonDataBusProp.selectedDataItem = value
      this.$emit('select', value)
    },
    isRowSelected (row) {
      if (this.commonDataBusProp.selectedDataItem == null) return false
      if (row.val.id === this.commonDataBusProp.selectedDataItem.val.id) return true
      else return false
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.dtv-flip-list-move {
  transition: transform 0.2s;
}
.sortable-chosen, /* тот который вначале при нажатии мышки и до начала движения мышки */
.sortable-drag,
.dtv-dragging-element {
  opacity: .5;
  background: rgb(108,118,175);
  color: #fff;
}


.dtv-properties-list-group {
  /*padding-bottom:5px;*/
  margin-left:20px;
}
.dtv-properties-list-group-item {
  background: #fff;
  /* сейчас этот padding заменен на то что .properties-list-group внутри .properties-list-group-item всегда отображается и имеет свой padding-top:5px;*/
  padding-bottom: 1px; /* надо обызятельно padding а не margin чтобы при dragging не было дрожаний когда таскаешь по списку элементов внутри которых пустые childrenи появляются области для drag */
}


/*.properties-list-group-empty {
  min-height: 0px;
}*/
/*.dragging-mode .properties-list-group-show-empty {*/
.dtv-properties-list-group-show-empty {
  margin:0px 0 0px 20px;
  min-height: 8px;/*23px;*/
  border: dashed 1px #ddd;
  background: #fafafa;
}


/*.dragging-mode .dragging-element .properties-list-group-show-empty,
.dragging-mode .sortable-chosen .properties-list-group-show-empty {*/
.dtv-dragging-element .dtv-properties-list-group-show-empty,
.sortable-chosen .dtv-properties-list-group-show-empty {
  display: none;
}


.dtv-property-box {
  /*cursor:pointer;*/
  border: solid 1px #ddd;
  padding: 5px 5px 5px 5px;
  border-radius: 3px;
  clear:left;
}
.dtv-property-box-as-root {
  color: #778087;
  background: #f5f5f5;
}
.dtv-property-box-as-not-root {
  color: #778087;
  background: #fff;
}
.dtv-property-box-selected {
  color: rgb(240,240,240);
  background: rgb(108,118,175);
}
.dtv-property-box-handle {
  padding: 0 5px 0 2px;
  cursor: move;
}
.dtv-property-box-action-button {
  cursor: pointer;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// DraggTreeview.vue?bff65870